'use strict';

var template =          require('../../templates/settings/Position.ejs');
var ItemView =          require('./PositionItem.js');
var ModalView =         require('./PositionItemModal.js');
var ListEditablesView = require('commons/views/ListEditables');
var modal =             require('helpers/modal');

import Position from 'newModels/position.js';

module.exports = ListEditablesView.extend({
    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            Model: Position,
            ModalEditView: ModalView,
            ModelView: ItemView
        });

        return ListEditablesView.prototype.initialize.apply(
            this, [this.options]
        );
    },

    createModel: function() {
        return new Position({company: app.company});
    },

    save: function(ev) {
        ListEditablesView.prototype.save.apply(this, [ev]).then(function() {
            modal.showAlertSuccess('Settings have been saved');
        });
        return false;
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/Position.js